import { toDate } from "common/utils/dates";

import ConfirmationDialog from "client/common/components/content/ConfirmationDialog";
import { useCurrentDialog } from "client/common/hooks/stackables";
import { useFeatures } from "client/clinics/hooks";

export type SubscriptionScheduleConfirmDialogProps = {
  bumpedDate: Date;
  onConfirm: () => void;
};

const SubscriptionScheduleConfirmDialog = ({
  bumpedDate,
  onConfirm,
}: SubscriptionScheduleConfirmDialogProps) => {
  const { close } = useCurrentDialog();
  const isEdbEnabled = useFeatures().AUTOSHIP_EDB;

  const description = isEdbEnabled
    ? `With this frequency, your next delivery would be sooner than we can get it to you, so it's set to the earliest available delivery, ${toDate(
        bumpedDate,
      )}. Your next order will be placed tomorrow.`
    : `With this frequency, your next order date would be today or earlier, so your next order will be placed tomorrow, ${toDate(
        bumpedDate,
      )}.`;

  return (
    <ConfirmationDialog
      title="Confirm your next order"
      description={description}
      denyText="Go back"
      confirmText="Yes, place it tomorrow"
      onConfirm={() => {
        close();
        onConfirm();
      }}
      onDeny={close}
    />
  );
};

export default SubscriptionScheduleConfirmDialog;
